import React from 'react';
import styled from 'styled-components';
import SEOProgressGauge from './SEOProgressGauge';

const GaugesWrapper = styled.div`
  margin-top: var(--spacing-6);
`;

const SectionTitle = styled.h3`
  margin: 0 0 var(--spacing-4) 0;
  color: var(--color-secondary);
  font-size: var(--font-size-lg);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
`;

const GaugesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--spacing-4);
  margin-bottom: var(--spacing-6);
`;

const CategorySection = styled.div`
  margin-bottom: var(--spacing-8);
`;

const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-3);
`;

interface CategoryStats {
  id: number;
  category_name: string;
  category_slug: string;
  total_products_in_category: number;
  products_with_seo_in_category: number;
  category_has_seo: boolean;
  seo_progress_percentage: number;
}

interface OverviewStats {
  total_products: number;
  products_with_seo: number;
  products_seo_percentage: number;
  total_categories: number;
  categories_with_seo: number;
  categories_seo_percentage: number;
  global_pages_with_seo: number;
}

interface SEOCategoryGaugesProps {
  overview: OverviewStats;
  categoryStats: CategoryStats[];
}

const SEOCategoryGauges: React.FC<SEOCategoryGaugesProps> = ({ overview, categoryStats }) => {
  return (
    <GaugesWrapper>
      <SectionTitle>📊 SEO Progress Översikt</SectionTitle>
      
      <GaugesGrid>
        <SEOProgressGauge
          title="Alla Produkter"
          completed={overview.products_with_seo}
          total={overview.total_products}
          description="Produkter med SEO-inställningar"
          icon="📦"
        />
        
        <SEOProgressGauge
          title="Alla Kategorier"
          completed={overview.categories_with_seo}
          total={overview.total_categories}
          description="Kategorier med SEO-inställningar"
          icon="📁"
        />
        
        <SEOProgressGauge
          title="Globala Sidor"
          completed={overview.global_pages_with_seo}
          total={1}
          description="Globala SEO-inställningar"
          icon="🌐"
        />
      </GaugesGrid>

      {categoryStats.length > 0 && (
        <CategorySection>
          <SectionTitle>📁 Progress per Kategori</SectionTitle>
          <CategoryGrid>
            {categoryStats.map(category => (
              <SEOProgressGauge
                key={category.id}
                title={category.category_name}
                completed={category.products_with_seo_in_category}
                total={category.total_products_in_category}
                description={`${category.total_products_in_category} produkt${category.total_products_in_category !== 1 ? 'er' : ''} i kategorin`}
                color={category.category_has_seo ? '#10b981' : undefined}
                icon={category.category_has_seo ? '✅' : '⚠️'}
              />
            ))}
          </CategoryGrid>
        </CategorySection>
      )}
    </GaugesWrapper>
  );
};

export default SEOCategoryGauges;